import "core-js/modules/es.array.push.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ae94a50"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sider"
};
const _hoisted_2 = {
  class: "sider-collapse-wrap"
};
const _hoisted_3 = {
  key: 1,
  class: "not-allowed-click"
};
const _hoisted_4 = {
  key: 3,
  class: "not-allowed-click"
};
const _hoisted_5 = {
  class: "app-container-wrap"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "subapp-viewport",
  key: "qiankun"
}, null, -1));
import { computed, h, reactive, ref, unref, watch } from 'vue';
import { AppstoreOutlined, AuditOutlined, ContainerOutlined, IdcardOutlined, MenuFoldOutlined, MenuUnfoldOutlined, PieChartOutlined, ReadOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import HeaderPage from './Header';
import { useTabsStore } from '@/stores';
import useGetGlobalProperties from '@/hooks/useGlobal';

import { onMounted, onUpdated } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      $hasRole
    } = useGetGlobalProperties();
    const current = ref(router.currentRoute.value.fullPath);
    const isLogin = ref(false);
    const isSider = ref(false);
    isLogin.value = current.value != '/login' && current.value != '/screen' && current.value != '/noPermission';
    const state = reactive({
      collapsed: false,
      openKeys: ['sub1'],
      preOpenKeys: ['sub1']
    });
    const items = reactive([{
      key: '/generalView',
      icon: () => h(PieChartOutlined),
      role: '/generalview',
      label: '总览',
      title: '总览'
    }, {
      key: '/basic',
      icon: () => h(AuditOutlined),
      label: '基础管理',
      role: '/basic',
      title: '基础管理',
      children: [{
        key: '/basicManage',
        icon: () => h(ContainerOutlined),
        role: '/basicmanage',
        label: '基本配置',
        title: '基本配置'
      }, {
        key: '/guide',
        icon: () => h(ContainerOutlined),
        role: '/guide',
        label: '引导页配置',
        title: '引导页配置'
      }, {
        key: '/bannerManage',
        icon: () => h(ContainerOutlined),
        role: '/bannermanage',
        label: 'Banner配置',
        title: 'Banner配置'
      }, {
        key: '/suggestFeedback',
        icon: () => h(ContainerOutlined),
        role: '/suggestfeedback',
        label: '建议与反馈',
        title: '建议与反馈'
      }]
    }, {
      key: '/homePageConfig',
      icon: () => h(IdcardOutlined),
      label: '首页配置',
      title: '首页配置',
      role: '/homePageConfig',
      children: [{
        key: '/questionAndHomeConfig',
        icon: () => h(ContainerOutlined),
        label: '题目&规则配置',
        role: '/questionAndHomeConfig',
        title: '题目&规则配置'
      }, {
        key: '/temperamentResult',
        icon: () => h(ContainerOutlined),
        label: '气质速测结果',
        role: '/temperamentResult',
        title: '气质速测结果'
      }, {
        key: '/eventCalendarConfig',
        icon: () => h(ContainerOutlined),
        label: '活动日历配置',
        role: '/eventCalendarConfig',
        title: '活动日历配置'
      }, {
        key: '/moodRecording',
        icon: () => h(ContainerOutlined),
        label: '心情日记记录',
        role: '/moodRecording',
        title: '心情日记记录'
      }]
    }, {
      key: '/testManage',
      icon: () => h(IdcardOutlined),
      label: '测评管理',
      title: '测评管理',
      role: '/testManage',
      children: [{
        key: '/scaleDesign',
        icon: () => h(ContainerOutlined),
        label: '量表设计',
        role: '/scaleDesign',
        title: '量表设计'
      }, {
        key: '/scaleResult',
        icon: () => h(ContainerOutlined),
        label: '量表结果',
        role: '/scaleResult',
        title: '量表结果'
      }]
    }, {
      key: '/severeMental',
      icon: () => h(IdcardOutlined),
      label: '重精管理',
      title: '重精管理',
      role: '/severeMental',
      children: [{
        key: '/sickInfoNameList',
        icon: () => h(ContainerOutlined),
        label: '病人信息名单',
        role: '/sickInfoNameList',
        title: '病人信息名单'
      }, {
        key: '/followUpStatistics',
        icon: () => h(ContainerOutlined),
        label: '回访数据统计',
        role: '/followUpStatistics',
        title: '回访数据统计'
      }, {
        key: '/pukouSevereMental',
        icon: () => h(ContainerOutlined),
        label: '浦口区重精管理',
        role: '/pukouSevereMental',
        title: '浦口区重精管理'
      }]
    }, {
      key: '/counselor',
      icon: () => h(IdcardOutlined),
      label: '咨询管理',
      title: '咨询管理',
      role: '/counselor',
      children: [{
        key: '/hotlineManage',
        icon: () => h(ContainerOutlined),
        label: '热线管理',
        role: '/hotlinemanage',
        title: '热线管理'
      }, {
        key: '/appointManage',
        icon: () => h(ContainerOutlined),
        label: '预约咨询管理',
        role: '/appointmanage',
        title: '预约咨询管理'
      }, {
        key: '/counselorSummary',
        role: '/counselorsummary',
        icon: () => h(ContainerOutlined),
        label: '咨询师自总结查询',
        title: '咨询师自总结查询'
      }]
    }, {
      key: '/aptitude',
      role: '/aptitude',
      icon: () => h(AppstoreOutlined),
      label: '资质管理',
      title: '资质管理',
      children: [{
        key: '/aptitudeAudit',
        role: '/aptitudeaudit',
        icon: () => h(ContainerOutlined),
        label: '资质认证待审核',
        title: '资质认证待审核'
      }, {
        key: '/aptitudeApproved',
        role: '/aptitudeapproved',
        icon: () => h(ContainerOutlined),
        label: '资质认证已审核',
        title: '资质认证已审核'
      }]
    }, {
      key: '/user',
      icon: () => h(AppstoreOutlined),
      role: '/user',
      label: '用户管理',
      title: '用户管理',
      children: [{
        key: '/personalInformation',
        role: '/personalinformation',
        icon: () => h(ContainerOutlined),
        label: '个人信息',
        title: '个人信息'
      }, {
        key: '/counselorInformation',
        role: '/counselorinformation',
        icon: () => h(ContainerOutlined),
        label: '咨询师信息',
        title: '咨询师信息'
      }, {
        key: '/teamUser',
        role: '/teamUser',
        icon: () => h(ContainerOutlined),
        label: '监测名单明细',
        title: '监测名单明细'
      }]
    },
    // {
    //   key: '/belong',
    //   role: '/belong',
    //   icon: () => h(AppstoreOutlined),
    //   label: '归属管理',
    //   title: '归属管理',
    //   children: [
    //     {
    //       key: '/regionConfig',
    //       role: '/regionconfig',
    //       icon: () => h(ContainerOutlined),
    //       label: '区域配置',
    //       title: '区域配置'
    //     },
    //     {
    //       key: '/organizeConfig',
    //       role: '/organizeconfig',
    //       icon: () => h(ContainerOutlined),
    //       label: '机构配置',
    //       title: '机构配置'
    //     }
    //   ]
    // },
    {
      key: '/dictionary',
      role: '/dictionary',
      icon: () => h(ReadOutlined),
      label: '字典管理',
      title: '字典管理',
      children: [{
        key: '/dicManage',
        role: '/dicmanage',
        icon: () => h(ContainerOutlined),
        label: '字典管理',
        title: '字典管理'
      }]
    }, {
      key: '/teamTest',
      role: '/teamTest',
      icon: () => h(AppstoreOutlined),
      label: '团测管理',
      title: '团测管理',
      children: [{
        key: '/careLevel',
        icon: () => h(ContainerOutlined),
        label: '关怀等级配置',
        role: '/careLevel',
        title: '关怀等级配置'
      }, {
        key: '/taskPackage',
        icon: () => h(ContainerOutlined),
        label: '任务量表套餐',
        role: '/taskPackage',
        title: '任务量表套餐'
      }, {
        key: '/packageDistribution',
        icon: () => h(ContainerOutlined),
        label: '量表套餐分配',
        role: '/packageDistribution',
        title: '量表套餐分配'
      }, {
        key: '/testTask',
        icon: () => h(ContainerOutlined),
        label: '团测任务管理',
        role: '/testTask',
        title: '团测任务管理'
      }, {
        key: '/taskTestList',
        icon: () => h(ContainerOutlined),
        label: '任务测评名单',
        role: '/taskTestList',
        title: '任务测评名单'
      }, {
        key: '/taskAnalysis',
        icon: () => h(ContainerOutlined),
        label: '任务数据分析',
        role: '/taskAnalysis',
        title: '任务数据分析'
      }, {
        key: '/taskReport',
        icon: () => h(ContainerOutlined),
        label: '团测任务报告',
        role: '/taskReport',
        title: '团测任务报告'
      }]
    }, {
      key: '/screen',
      icon: () => h(PieChartOutlined),
      role: '/screen',
      label: '大屏管理',
      title: '大屏管理'
    }, {
      key: '/organizationChart',
      icon: () => h(PieChartOutlined),
      role: '/organizationChart',
      label: '组织架构',
      title: '组织架构'
    }]);
    const menus = computed(() => filterMenu(unref(items)));
    const openKeyItem = computed(() => {
      let current = router.currentRoute.value.fullPath;
      if (current === '/console') current = '/generalView';
      if (current === '/home' || current === '/noPermission') isSider.value = false;
      const menuList = unref(menus);
      const menuItem = menuList.find(o => {
        if (o.key === current) return true;
        const children = o.children ?? [];
        const route = children.find(c => c.key === current);
        return !!route;
      });
      return menuItem ? menuItem.key : '';
    });
    const visible = ref(false);
    const top = ref(0);
    const left = ref(0);
    async function handleClick_sider(e) {
      const {
        key
      } = e;
      if (key === '/screen') {
        window.open(`${process.env.VUE_APP_BASE_URL}${key}`);
      } else {
        await router.push(key);
        updateTab(key);
      }
    }
    const tabsStore = useTabsStore();

    // tabs的内容
    const tabs = ref(tabsStore._tabs());
    onMounted(async () => {
      const current = router.currentRoute.value.fullPath;
      let key = current;
      if (current === '/console') key = '/generalView';
      state.openKeys[0] = unref(openKeyItem);
      tabsStore.setSelectedKeys(key);
      await router.push(key);
      updateTab(key);
    });
    onUpdated(async () => {
      const current = router.currentRoute.value.fullPath;
      isLogin.value = true;
      if (current === '/console') {
        const key = '/generalView';
        tabsStore.setSelectedKeys(key);
        await router.push(key);
        updateTab(key);
      } else if (current === '/noPermission') {
        isSider.value = false;
        isLogin.value = false;
      }
      isLogin.value = current != '/login' && current.value != '/screen';
    });
    function updateTab(fullPath) {
      const tabItems = tabsStore._tabs();
      const tabItemFullPaths = tabItems.map(item => item.route);
      // 当前tab的名称
      const currentName = router.currentRoute.value.name;
      if (!tabItemFullPaths.includes(fullPath) && fullPath !== '/console' && fullPath !== '/home' && fullPath !== '/login' && fullPath !== '/noPermission') {
        tabsStore.addTab({
          route: fullPath,
          label: currentName || '未命名页面'
        });
      }
      tabsStore.setActiveKey(fullPath);
    }
    watch(() => state.openKeys, (_val, oldVal) => {
      state.preOpenKeys = oldVal;
    });
    watch(visible, value => {
      if (value) {
        document.body.addEventListener('click', closeMenu);
      } else {
        document.body.removeEventListener('click', closeMenu);
      }
    });
    function toggleCollapsed() {
      state.collapsed = !state.collapsed;
      state.openKeys = state.collapsed ? [] : state.preOpenKeys;
    }

    // 编辑tab
    function onEdit(targetKey, action) {
      if (action === 'remove') remove(targetKey);
    }

    // 移除一个tab
    function remove(targetKey) {
      const tabItems = tabsStore._tabs();
      // 当前tab的数量
      const len = tabItems.length;
      // 如果当前版本的数量为1就不需要移除
      if (len === 1) return;
      const tabItemRoutes = tabItems.map(item => item.route);
      if (tabItemRoutes.includes(targetKey)) {
        const tabItem = tabItems.filter(item => item.route === targetKey)[0];
        tabsStore.removeTab(tabItem);
      }
      // 跳转到第一个路径下
      const linkPath = tabItems[0].route;
      tabsStore.setActiveKey(linkPath);
      router.push(linkPath);
    }

    // 点击tab页
    function clickTab(tabRouter) {
      router.push(tabRouter);
      tabsStore.setSelectedKeys(tabRouter);
    }

    /**
     * 权限点筛选菜单
     */
    function filterMenu(childrenMenus) {
      return childrenMenus.reduce((prev, current) => {
        if (!current.role || current.role === '') {
          prev.push(current);
        } else if ($hasRole(current.role, '2')) {
          const {
            children
          } = current;
          if (children && children.length !== 0) current.children = filterMenu(children);
          prev.push(current);
        }
        return prev;
      }, []);
    }
    function siderVisible(value) {
      if (value === 'console') isSider.value = true;else isSider.value = false;
    }

    // 关闭其他tab页
    function closeOthersTags(targetKey) {
      const tabItems = tabsStore._tabs();
      const tabItemRoutes = tabItems.map(item => item.route);
      tabItemRoutes.forEach(item => {
        if (item !== targetKey) {
          const tabItem = tabItems.filter(i => i.route === item)[0];
          tabsStore.removeTab(tabItem);
        }
      });
    }

    // 打开tab右键菜单
    function openMenu(tag, e) {
      left.value = e.clientX;
      top.value = e.clientY;
      visible.value = true;
    }

    // 关闭tab右键菜单
    function closeMenu() {
      visible.value = false;
    }
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_layout_sider = _resolveComponent("a-layout-sider");
      const _component_a_layout_header = _resolveComponent("a-layout-header");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_router_view = _resolveComponent("router-view");
      const _component_a_layout_content = _resolveComponent("a-layout-content");
      const _component_a_layout = _resolveComponent("a-layout");
      return _openBlock(), _createBlock(_component_a_layout, {
        "has-sider": "",
        class: "app-wrapper"
      }, {
        default: _withCtx(() => [isSider.value ? (_openBlock(), _createBlock(_component_a_layout_sider, {
          key: 0,
          collapsed: state.collapsed,
          "onUpdate:collapsed": _cache[2] || (_cache[2] = $event => state.collapsed = $event),
          class: "menu-container",
          trigger: null,
          collapsible: "",
          "collapsed-width": 70
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_button, {
            type: "link",
            class: "sider-collapse-btn",
            onClick: toggleCollapsed
          }, {
            default: _withCtx(() => [state.collapsed ? (_openBlock(), _createBlock(_unref(MenuUnfoldOutlined), {
              key: 0
            })) : (_openBlock(), _createBlock(_unref(MenuFoldOutlined), {
              key: 1
            }))]),
            _: 1
          })]), _createVNode(_component_a_menu, {
            openKeys: state.openKeys,
            "onUpdate:openKeys": _cache[0] || (_cache[0] = $event => state.openKeys = $event),
            selectedKeys: _unref(tabsStore).selectedKeys,
            "onUpdate:selectedKeys": _cache[1] || (_cache[1] = $event => _unref(tabsStore).selectedKeys = $event),
            class: "sider-nav-menu",
            mode: "inline",
            "inline-collapsed": state.collapsed,
            items: menus.value,
            onClick: handleClick_sider
          }, null, 8, ["openKeys", "selectedKeys", "inline-collapsed", "items"])])]),
          _: 1
        }, 8, ["collapsed"])) : _createCommentVNode("", true), _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [isLogin.value ? (_openBlock(), _createBlock(_component_a_layout_header, {
            key: 0,
            class: "page-header",
            style: {
              "height": "50px",
              "line-height": "50px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(HeaderPage), {
              onSiderVisible: siderVisible
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_a_layout_content, {
            class: "main-content"
          }, {
            default: _withCtx(() => [isSider.value ? (_openBlock(), _createBlock(_component_a_tabs, {
              key: 0,
              activeKey: _unref(tabsStore).activeKey,
              "onUpdate:activeKey": _cache[3] || (_cache[3] = $event => _unref(tabsStore).activeKey = $event),
              "hide-add": "",
              type: "editable-card",
              class: "header-tabs",
              onEdit: onEdit,
              onTabClick: clickTab,
              onContextmenu: _cache[4] || (_cache[4] = _withModifiers($event => openMenu(_unref(tabsStore).activeKey, $event), ["prevent"]))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, tab => {
                return _openBlock(), _createBlock(_component_a_tab_pane, {
                  key: tab.route,
                  tab: tab.label
                }, null, 8, ["tab"]);
              }), 128))]),
              _: 1
            }, 8, ["activeKey"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("ul", {
              style: _normalizeStyle({
                left: left.value + 'px',
                top: top.value + 'px'
              }),
              class: "contextmenu"
            }, [tabs.value.length > 1 ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              onClick: _cache[5] || (_cache[5] = $event => remove(_unref(tabsStore).activeKey))
            }, "关闭")) : (_openBlock(), _createElementBlock("li", _hoisted_3, "关闭")), tabs.value.length > 1 ? (_openBlock(), _createElementBlock("li", {
              key: 2,
              onClick: _cache[6] || (_cache[6] = $event => closeOthersTags(_unref(tabsStore).activeKey))
            }, "关闭其他")) : (_openBlock(), _createElementBlock("li", _hoisted_4, "关闭其他"))], 4), [[_vShow, visible.value]]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view, {
              key: "router"
            }), _hoisted_6])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};